import { defaultNotificationDataInjector } from './default-notification-type-handler'
import { FallBackNotification } from './fallback-notification-class'

export function buildFallBackNotificationData(notificationData, variablesForUse = {}) {
  const fallBackNotificationData = new FallBackNotification({
    notificationData,
    variablesForUse,
  })
  const dataInjector = defaultNotificationDataInjector

  dataInjector(fallBackNotificationData)

  return fallBackNotificationData
}
